import { create } from 'zustand';
import type { AuthSession, User, UserRole } from '@kick/types';

interface EstadoAuth {
  /**
   * El access token vive **solo en memoria**, nunca en localStorage.
   * Si se guardara, cualquier script inyectado en la página podría leerlo.
   * Al recargar se recupera la sesión con la cookie httpOnly de refresh.
   */
  accessToken: string | null;
  user: User | null;
  merchantId: string | null;
  mustChangePassword: boolean;
  /** Mientras se intenta restaurar la sesión al cargar la página. */
  cargando: boolean;

  iniciar: (sesion: AuthSession) => void;
  actualizarToken: (token: string) => void;
  /** Levanta el bloqueo tras cambiar la contraseña temporal. */
  marcarPasswordCambiada: () => void;
  cerrar: () => void;
  terminarCarga: () => void;
}

export const useAuth = create<EstadoAuth>((set) => ({
  accessToken: null,
  user: null,
  merchantId: null,
  mustChangePassword: false,
  cargando: true,

  iniciar: (sesion) =>
    set({
      accessToken: sesion.accessToken,
      user: sesion.user,
      merchantId: sesion.merchantId ?? null,
      mustChangePassword: sesion.mustChangePassword ?? false,
      cargando: false,
    }),

  actualizarToken: (accessToken) => set({ accessToken }),

  marcarPasswordCambiada: () => set({ mustChangePassword: false }),

  cerrar: () =>
    set({
      accessToken: null,
      user: null,
      merchantId: null,
      mustChangePassword: false,
      cargando: false,
    }),

  terminarCarga: () => set({ cargando: false }),
}));

/** Lectura del token fuera de React (la usa el interceptor de Axios). */
export const obtenerToken = (): string | null => useAuth.getState().accessToken;

export const esAdmin = (rol?: UserRole | null): boolean => rol === 'ADMIN';
export const esComercio = (rol?: UserRole | null): boolean =>
  rol === 'MERCHANT_OWNER' || rol === 'MERCHANT_STAFF';
